import getPaginationRange from '../get-pagination-range';

const AMOUNT_OF_PAGES_WITHOUT_ELLIPSIS = 4;

type GetPaginationPagesToDisplayParams = {
  amountOfPages: number;
  currentPageNumber: number;
};

const getPaginationPagesToDisplay = ({ amountOfPages, currentPageNumber }: GetPaginationPagesToDisplayParams) => {
  const showEllipsis = amountOfPages > AMOUNT_OF_PAGES_WITHOUT_ELLIPSIS;
  const firstPage = 1;
  const ellipsis = '...';

  // Show all page numbers if the amount of pages is within the range to show all
  if (!showEllipsis) {
    return getPaginationRange(firstPage, amountOfPages);
  }

  // If the current page is near the start, but the amount of pages is larger than the range to show all
  if (currentPageNumber <= 2) {
    return [...getPaginationRange(firstPage, 3), ellipsis, amountOfPages];
  }

  // If the current page is near the end, show the first page, an ellipsis, and the last few pages
  if (currentPageNumber >= amountOfPages - 1) {
    return [firstPage, ellipsis, ...getPaginationRange(amountOfPages - 2, amountOfPages)];
  }

  // Show the current page in the middle between two ellipsis and at the start and end show the first and last pages
  return [firstPage, ellipsis, currentPageNumber, ellipsis, amountOfPages];
};

export default getPaginationPagesToDisplay;
